import Link from "./Link";
import "firebase/analytics";
import {setDocByDocId} from "@/shared/firebase_utils";

class LinkInBio {
  constructor({
    id = "",
    businessProfileId = "",
    links = [],
    businessName = "",
    city = "",
    country = "",
    hasPhoneNumber = false,
    phoneNumber = "",
    hasEmail = false,
    email = "",
    hasWebsite = false,
    website = "",
    hasFacebook = false,
    facebook = "",
    hasInstagram = false,
    instagram = "",
    hasLinkedIn = false,
    linkedIn = "",
    hasTwitter = false,
    twitter = "",
    hasYoutube = false,
    youtube = "",
    hasPodcast = false,
    podcast = "",
    displayImageURL = "",
    reverseImageURL = "",
    backgroundImageURL = "",
    pappyonCardLink = "",
    hasPappyonCardLink = false,
    hasFeatureCardLink = false,
    cardBackUrl = "",
  }) {
    (this.id = id),
      (this.businessProfileId = businessProfileId),
      (this.links = links),
      (this.businessName = businessName),
      (this.city = city),
      (this.country = country || ""),
      (this.hasPhoneNumber = hasPhoneNumber),
      (this.phoneNumber = phoneNumber),
      (this.hasEmail = hasEmail),
      (this.email = email),
      (this.hasWebsite = hasWebsite),
      (this.website = website),
      (this.hasFacebook = hasFacebook),
      (this.facebook = facebook),
      (this.hasInstagram = hasInstagram),
      (this.instagram = instagram),
      (this.hasLinkedIn = hasLinkedIn),
      (this.linkedIn = linkedIn),
      (this.hasTwitter = hasTwitter),
      (this.twitter = twitter),
      (this.hasYoutube = hasYoutube),
      (this.youtube = youtube),
      (this.hasPodcast = hasPodcast),
      (this.podcast = podcast),
      (this.displayImageURL = displayImageURL),
      (this.reverseImageURL = reverseImageURL),
      (this.backgroundImageURL = backgroundImageURL),
      (this.hasPappyonCardLink = hasPappyonCardLink),
      (this.pappyonCardLink = pappyonCardLink),
      (this.hasFeatureCardLink = hasFeatureCardLink || false),
      (this.cardBackUrl = cardBackUrl || "");
  }
  toFirestore() {
    return {
      id: this.id,
      businessProfileId: this.businessProfileId,
      links: this.links?.map((link) => link.toObject()) || [],
      businessName: this.businessName,
      city: this.city,
      country: this.country || "",
      hasPhoneNumber: this.hasPhoneNumber || false,
      phoneNumber: this.phoneNumber,
      hasEmail: this.hasEmail || false,
      email: this.email,
      hasWebsite: this.hasWebsite || false,
      website: this.website,
      hasFacebook: this.hasFacebook || false,
      facebook: this.facebook,
      hasInstagram: this.hasInstagram || false,
      instagram: this.instagram,
      hasLinkedIn: this.hasLinkedIn || false,
      linkedIn: this.linkedIn,
      hasTwitter: this.hasTwitter || false,
      twitter: this.twitter,
      hasYoutube: this.hasYoutube || false,
      youtube: this.youtube,
      hasPodcast: this.hasPodcast || false,
      podcast: this.podcast,
      displayImageURL: this.displayImageURL,
      reverseImageURL: this.reverseImageURL,
      backgroundImageURL: this.backgroundImageURL,
      hasPappyonCardLink: this.hasPappyonCardLink || false,
      pappyonCardLink: this.pappyonCardLink,
      cardBackUrl: this.cardBackUrl || "",
      hasFeatureCardLink: this.hasFeatureCardLink || false,
    };
  }

  static fromFireStore(data) {
    return new LinkInBio({
      id: data.id,
      businessProfileId: data.businessProfileId,
      links: data.links?.map((link) => Link.fromObject(link)) || [],
      businessName: data.businessName,
      city: data.city,
      country: data.country || "",
      hasPhoneNumber: data.hasPhoneNumber || false,
      phoneNumber: data.phoneNumber,
      hasEmail: data.hasEmail || false,
      email: data.email,
      hasWebsite: data.hasWebsite || false,
      website: data.website,
      hasFacebook: data.hasFacebook || false,
      facebook: data.facebook,
      hasInstagram: data.hasInstagram || false,
      instagram: data.instagram,
      hasLinkedIn: data.hasLinkedIn || false,
      linkedIn: data.linkedIn,
      hasTwitter: data.hasTwitter || false,
      twitter: data.twitter,
      hasYoutube: data.hasYoutube || false,
      youtube: data.youtube,
      hasPodcast: data.hasPodcast || false,
      podcast: data.podcast,
      displayImageURL: data.displayImageURL,
      reverseImageURL: data.reverseImageURL,
      backgroundImageURL: data.backgroundImageURL,
      hasPappyonCardLink: data.hasPappyonCardLink || false,
      pappyonCardLink: data.pappyonCardLink,
      cardBackUrl: data.cardBackUrl || "",
      hasFeatureCardLink: data.hasFeatureCardLink || false,
    });
  }

  async save() {
    try {
      await setDocByDocId("link_in_bio", this.id, this.toFirestore());
    } catch (err) {
      console.log("Error occurred while saving linkInBio to firestore: ", err);
    }
  }
}

export default LinkInBio;
